// extracted by mini-css-extract-plugin
export default {"table":"ApuracaoResultado_table__N1cxL","buttonRight":"ApuracaoResultado_buttonRight__fgnsg","containerMetas":"ApuracaoResultado_containerMetas__oJsFI"};